export const documentTypes = () => [
  { label: 'DNI', value: 'dni' },
  { label: 'DU', value: 'du' },
  { label: 'Pasaporte', value: 'passport' },
]
